var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._b({staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"props":_vm.props},on:{"input":_vm.handleInput},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{},[_c('span',{staticClass:"el-icon-space",class:_vm.getOrgTypeIconByCode(data.type)},[_vm._v(_vm._s(node.label))])])}}])},'el-cascader',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }